import { ServiceBase } from "@app/shared";
import { AccuracyGapAnalysisUiProps } from "../accuracy-gap-analysis/AccuracyGapAnalysisContext";

/** Handles communication across the wire when retrieving and interacting with AGA Results. */
export default class AccuracyGapAnalysisService extends ServiceBase {

  /**
   * Retrieve the AGA results
   * @param projectId The project Id
   * @param projectRunConfigurationId The project run configuration id
   * @param publishStatus The status of publish of the project
   */

  public async getAccuracyGapAnalysisData(projectId: number, projectRunConfigurationId: number, publishStatus: boolean): Promise<AccuracyGapAnalysisUiProps> {
    return await this.makeGet<AccuracyGapAnalysisUiProps>("AccuracyGapAnalysis", { customProjectId: projectId, projectRunConfigurationId: projectRunConfigurationId, publishStatus: publishStatus });
  }

  public async rerunAccuracyGapAnalysis(projectId: number, projectRunConfigurationId: number): Promise<boolean>  {
    return await this.makePost<boolean>("AccuracyGapAnalysis/RerunAccuracyGapAnalysis", { customProjectId: projectId, projectRunConfigurationId: projectRunConfigurationId });
  }
}
